var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsConfirmedOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#DB536A;}\n\t.st2{fill:#E0301E;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#464646;}\n\t.st5{fill:#7D7D7D;}\n\t.st6{fill:#2D2D2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2_8_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Confirmed_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape_7_",
    d: "M82.9,43.7c0.4,1.9,0.6,3.8,0.6,5.8C83.5,66.9,69.4,81,52,81c-17.4,0-31.5-14.1-31.5-31.5 C20.5,32.1,34.6,18,52,18c5.2,0,10.3,1.3,14.8,3.7l3.3-3.3c-5.3-3.1-11.5-4.9-18.1-4.9c-19.9,0-36,16.1-36,36 c0,19.9,16.1,36,36,36c19.9,0,36-16.1,36-36c0-3.3-0.5-6.5-1.3-9.5L82.9,43.7z M42.1,44.8l-3.2,3.2l12,12L84,26.7l-3.2-3.2 l-29.9,30L42.1,44.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsConfirmedOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Confirmed_Outline_Black_RGB.3ccfe024814c5810ffd91b4f9d865bd1.svg";
export { ForwardRef as ReactComponent };